<section class="container">
  <form [formGroup]="dataForm" (ngSubmit)="onSubmit()">
    <div class="section-one-main">
      <div class="sec-one-inputs">
        <div class="search-form">
          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="menu"
              class="nested-sec-select"
              #buttonElementSELECT_LOCATION>
              <span>
                {{
                  isSelectedValue
                    ? isSelectedValueName
                    : ('SEARCH_FILTER.SELECT_LOCATION' | translate)
                }}
              </span>

              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #menu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_LOCATION.offsetWidth + 'px',
                }">
                {{ 'SEARCH_FILTER.PICK_REGION' | translate }}
              </p>
              @for (disData of divisions; track disData.id) {
                <button
                  (click)="
                    onSelectBtnDis(
                      disData?.slug,
                      'divisions',
                      $event,
                      disData.name
                    )
                  "
                  class="divisions parent-btn"
                  type="button"
                  [ngStyle]="{
                    'min-width':
                      buttonElementSELECT_LOCATION.offsetWidth + 'px',
                  }">
                  {{ disData?.name }}
                  @if (isSelectedValue === disData?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
                @for (area of disData?.area; track area.slug) {
                  <div class="child-container">
                    <button
                      (click)="
                        onSelectBtnDis(area?.slug, 'area', $event, area?.name)
                      "
                      class="area child-btn"
                      type="button">
                      {{ area.name }}
                      @if (isSelectedValue === area?.slug) {
                        <span>
                          <i class="fas fa-check"></i>
                        </span>
                      }
                    </button>
                    @for (zone of area?.zone; track zone) {
                      <button
                        (click)="
                          onSelectBtnDis(zone?.slug, 'zone', $event, zone?.name)
                        "
                        class="zone child-btn"
                        type="button">
                        {{ zone?.name }}
                        @if (isSelectedValue === zone?.slug) {
                          <span>
                            <i class="fas fa-check"></i>
                          </span>
                        }
                      </button>
                    }
                  </div>
                }
              }
            </mat-menu>
          </div>
          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="categoryMenu"
              class="nested-sec-select"
              #buttonElementSELECT_CATEGORY>
              <span>
                {{
                  isSelectedValueCategory
                    ? getCategoryName(isSelectedValueCategory)
                    : ('SEARCH_FILTER.SELECT_CATEGORY' | translate)
                }}
              </span>

              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #categoryMenu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_CATEGORY.offsetWidth + 'px',
                }">
                {{ 'SEARCH_FILTER.SELECT_CATEGORY' | translate }}
              </p>
              @for (data of categorys; track data.id) {
                <button
                  (click)="onSelectBtnCategory(data?.slug, $event)"
                  class="divisions"
                  type="button"
                  [ngStyle]="{
                    'min-width':
                      buttonElementSELECT_CATEGORY.offsetWidth + 'px',
                  }">
                  {{ data?.name }}
                  @if (isSelectedValueCategory === data?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
              }
            </mat-menu>
          </div>
          <!-- END! sec-home-input-area (category) -->

          <div class="sec-home-input-area">
            <button
              type="button"
              [matMenuTriggerFor]="typeMenu"
              class="nested-sec-select"
              #buttonElementSELECT_TYPE>
              <span>
                {{
                  isSelectedValueType
                    ? getTypeName(isSelectedValueType)
                    : ('SEARCH_FILTER.SELECT_TYPE' | translate)
                }}
              </span>

              <i class="fa-solid fa-angle-down"></i>
            </button>

            <mat-menu #typeMenu="matMenu" class="mat-menu sec-one-mat">
              <p
                [ngStyle]="{
                  'min-width': buttonElementSELECT_TYPE.offsetWidth + 'px',
                }">
                {{ 'SEARCH_FILTER.SELECT_TYPE' | translate }}
              </p>
              @for (data of types; track data.id) {
                <button
                  (click)="onSelectBtnType(data?.slug, $event)"
                  class="divisions"
                  type="button"
                  [ngStyle]="{
                    'min-width': buttonElementSELECT_TYPE.offsetWidth + 'px',
                  }">
                  {{ data?.name }}
                  @if (isSelectedValueType === data?.slug) {
                    <span>
                      <i class="fas fa-check"></i>
                    </span>
                  }
                </button>
              }
            </mat-menu>
          </div>
          <!-- END! sec-home-input-area (type) -->

          <div class="sec-home-input-area">
            <form
              class="search-form-container"
              (click)="onClickSearchArea($event)">
              <input
                #searchInput
                id="searchInput"
                class="tw"
                type="text"
                [placeholder]="'SEARCH_FILTER.ENTER_KEYWORD' | translate"
                (focus)="handleFocus()"
                name="searchTerm"
                autocomplete="off"
                [(ngModel)]="searchQuery"
                (keydown.enter)="onSearchNavigate()" />
              @if (searchQuery) {
                <mat-icon
                  class="clear-search"
                  (click)="resetSearch()"
                  aria-label="Clear search input"
                  ><i class="fa fa-times" aria-hidden="true"></i
                ></mat-icon>
              }
            </form>
          </div>

          <div class="sec-home-sub-btn">
            <button type="submit">
              {{ 'SEARCH_FILTER.SEARCH' | translate }}
            </button>
          </div>

          <div class="btn-container mobile">
            <div class="sec-home-sub-btn sec-home-sub-btn-second">
              <button type="button" (click)="onHideFilter()">
                {{ 'SEARCH_FILTER.MORE_FILTERS' | translate | uppercase }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-container desktop">
      <div class="sec-home-sub-btn sec-home-sub-btn-second">
        <button type="button" (click)="onHideFilter()">
          {{ 'SEARCH_FILTER.MORE_FILTERS' | translate | uppercase }}
        </button>
      </div>
    </div>
    @if (advancedFilter) {
      <div class="filter-area">
        <div class="filter-area-three">
          <div class="filter-area-three-range-slider">
            <div class="filter-area-three-range-slider-top">
              <p>{{ 'SEARCH_FILTER.HEIGHT' | translate }}</p>
            </div>
            <mat-slider
              class="mdc-slider"
              formGroupName="height"
              min="140"
              max="220"
              discrete
              [displayWith]="formatLabel">
              <input formControlName="minHeight" matSliderStartThumb />
              <input formControlName="maxHeight" matSliderEndThumb />
            </mat-slider>
          </div>
          <!-- END! filter-area-three-range-slider -->
          <div class="filter-area-three-range-slider">
            <div class="filter-area-three-range-slider-top">
              <p>{{ 'SEARCH_FILTER.WEIGHT' | translate }}</p>
            </div>
            <mat-slider
              min="40"
              max="300"
              discrete
              formGroupName="weight"
              [displayWith]="formatLabel">
              <input formControlName="minWeight" matSliderStartThumb />
              <input formControlName="maxWeight" matSliderEndThumb />
            </mat-slider>
          </div>
          <!-- END! filter-area-three-range-slider -->
          <div class="filter-area-three-range-slider">
            <div class="filter-area-three-range-slider-top">
              <p>{{ 'SEARCH_FILTER.AGE' | translate }}</p>
            </div>
            <mat-slider
              min="18"
              max="80"
              discrete
              [displayWith]="formatLabel"
              formGroupName="age">
              <input formControlName="minAge" matSliderStartThumb />
              <input formControlName="maxAge" matSliderEndThumb />
            </mat-slider>
          </div>
          <!-- END! filter-area-three-range-slider -->
        </div>
        <div class="filter-area-child-one">
          <div class="sec-home-input-area-par">
            <label>{{ 'SEARCH_FILTER.BODY_TYPE' | translate }}</label>
            <div class="sec-home-input-area">
              <select formControlName="bodytype">
                <option value="null" hidden>
                  {{ 'SEARCH_FILTER.ALL_TYPES' | translate }}
                </option>
                @for (data of bodyTypes; track data.id; let i = $index) {
                  <option [value]="data.slug">{{ data.name }}</option>
                }
              </select>
            </div>
          </div>
          <!-- END! sec-home-input-area-par -->
          <div class="sec-home-input-area-par">
            <label>{{ 'SEARCH_FILTER.HAIR_COLOR' | translate }}</label>
            <div class="sec-home-input-area">
              <select formControlName="hairColor">
                <option value="null" hidden>
                  {{ 'SEARCH_FILTER.ALL_TYPES' | translate }}
                </option>
                @for (data of hairColors; track data.slug; let i = $index) {
                  <option [value]="data.slug">{{ data.name }}</option>
                }
              </select>
            </div>
          </div>
          <!-- END! sec-home-input-area-par -->
          <div class="sec-home-input-area-par">
            <label for="IntimateHair">{{
              'SEARCH_FILTER.PUBICHAIR' | translate
            }}</label>
            <div class="sec-home-input-area">
              <select id="IntimateHair" formControlName="intimateHairs">
                <option value="null" hidden>
                  {{ 'SEARCH_FILTER.ALL_TYPES' | translate }}
                </option>
                @for (data of intimateHairs; track data.slug) {
                  <option [value]="data.slug">
                    {{ data.name }}
                  </option>
                }
              </select>
            </div>
          </div>
          <!-- END! sec-home-input-area-par -->
        </div>
        <div class="filter-area-child-filter">
          <div class="filter-area-check">
            <input
              id="isGoingOut"
              type="checkbox"
              formControlName="isGoingOut" />
            <label for="isGoingOut">{{
              'SEARCH_FILTER.DRIVING_ESCORT' | translate
            }}</label>
          </div>
          <div class="filter-area-check">
            <input id="ownPlace" type="checkbox" formControlName="ownPlace" />
            <label for="ownPlace">{{
              'SEARCH_FILTER.OWN_PLACE' | translate
            }}</label>
          </div>
          <div class="filter-area-check">
            <input
              id="acceptsHandicapped"
              type="checkbox"
              formControlName="acceptsHandicapped" />
            <label for="acceptsHandicapped">{{
              'SEARCH_FILTER.ACCEPTS_HANDICAPPED' | translate
            }}</label>
          </div>
          <div class="filter-area-check">
            <input id="verified" type="checkbox" formControlName="verified" />
            <label for="verified">{{
              'SEARCH_FILTER.VERIFIED' | translate
            }}</label>
          </div>
        </div>
        <div class="filter-area-child-two">
          <div class="filter-area-btn">
            <button type="button" (click)="resetFilter()">
              {{ 'SEARCH_FILTER.CLEAR_FILTERS' | translate }}
            </button>
          </div>
          <div class="filter-area-btn filter-area-btn-search">
            <button type="button" (click)="onSubmit()">
              <i class="fa-solid fa-magnifying-glass"></i>
              <span>{{ 'SEARCH_FILTER.SEARCH' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    }
  </form>
</section>
